/**
 * @type {{
 *  boldClient: import('@boldxchange/sdk/defs').Client
 * }}
 */
const singleton = {};
module.exports = singleton;